export class SliderOverlay {
  mode = 'caption';
  overlayOnHover: boolean;
  animateBackgroundOnly: boolean;
  style = '';
  padding = '';
  position = 'uk-position-center';
  margin = '';
  maxWidth = '';
  transition = 'uk-transition-fade';
  linkType: 'slider' | 'title' | 'button' = 'slider';
}
